import { DxlInformation, ProductBundle } from '@/types/Product.types';
import {
  SWSmallPricingCardTitle,
  SWSmallPricingCardWrapper,
  SWSmallPricingCardDetails,
  SWSmallPricingCardDetailsPrice,
  SWSmallPricingCardDetailsPeriod,
  Spacer,
  SWSmallPricingCardFeatures,
  SWSmallPricingCardFeaturesItem,
} from '../SWSmallPricingCard.styles';
import { Button } from '@legacy-vfuk/core-button';
import { useBasket } from '@/hooks';
import { SWSmallPricingCardProps } from '../SWSmallPricingCard.types';
import { Icon } from '@legacy-vfuk/core-icon';

export const SingleNoQuantity = ({
  product,
  customName,
  buttonAction,
  priceDescription,
  features,
  productBundle,
}: Omit<SWSmallPricingCardProps, 'cardType' | 'name'> & {
  productBundle: (ProductBundle & { dxlInformation?: DxlInformation }) | undefined;
}) => {
  const { quantity, buttonText, handleButtonAction } = useBasket({
    item: { ...product, buttonsAction: buttonAction },
    nextStep: '',
    pathname: '',
  });

  return (
    <SWSmallPricingCardWrapper height={'auto'}>
      <SWSmallPricingCardTitle>{customName || product.name}</SWSmallPricingCardTitle>
      <SWSmallPricingCardDetails>
        <SWSmallPricingCardDetailsPrice>
          &euro; {(Number(productBundle?.dxlInformation?.price[0].price) * quantity).toFixed(2)}
        </SWSmallPricingCardDetailsPrice>
        <Spacer height={'15px'} />
        <SWSmallPricingCardDetailsPeriod>{priceDescription}</SWSmallPricingCardDetailsPeriod>
      </SWSmallPricingCardDetails>
      <Spacer height={'25px'} />
      <Button text={buttonText()} onClick={e => handleButtonAction(e)} />
      {features && features.length > 0 && (
        <>
          <Spacer height={'25px'} />
          <SWSmallPricingCardFeatures>
            {features?.map(feature => (
              <SWSmallPricingCardFeaturesItem key={feature}>
                <Icon group={'system'} name={'tick-circle'} size={1} />
                {feature}
              </SWSmallPricingCardFeaturesItem>
            ))}
          </SWSmallPricingCardFeatures>
        </>
      )}
    </SWSmallPricingCardWrapper>
  );
};
